import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// CSRF double-submit: echo the readable csrf_token cookie back as a header on state-changing requests.
function getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const token = getCookie("csrf_token");
    if (token) config.headers["X-CSRF-Token"] = token;
  }
  return config;
});

// On session expiry (401), send the user cleanly to the login page instead of surfacing
// an uncaught error. Skip the login/auth-check calls themselves so their errors flow normally.
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const detail = error?.response?.data?.detail;
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/me");
    // Auto-recover from a CSRF token mismatch: refresh the token via /auth/me, then replay once.
    if (
      status === 403 &&
      typeof detail === "string" &&
      detail.toLowerCase().includes("csrf") &&
      error.config &&
      !error.config._csrfRetried
    ) {
      try {
        await api.get("/auth/me");
        error.config._csrfRetried = true;
        const token = getCookie("csrf_token");
        if (token) error.config.headers["X-CSRF-Token"] = token;
        return api(error.config);
      } catch (e) {
        console.warn("CSRF auto-recovery failed; rejecting request", e?.message || e);
      }
    }
    if (status === 401 && !isAuthCall && typeof window !== "undefined") {
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

export const fileUrl = (path) => `${API}/files/${path}`;

export default api;
